module.exports = __webpack_public_path__ + "assets/images/businessCard-01.c4460df2b8a85a7d80079a42e14f3ed4.svg";